import 'jquery-toast-plugin';
import 'jquery-toast-plugin/dist/jquery.toast.min.css';
import {WebshopRootScope} from "@/models";
import {IModalInstanceService} from "@core/global";

export type ToastOptions = {
    text?: string;
    icon?: 'success' | 'error' | 'warning' | 'info';
    position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | string;
    loader?: boolean;
    hideAfter?: number | boolean;
    stack?: number | boolean;
    heading?: string;
    [key: string]: any;
}

export interface INotificationService {
    disabledInput: any[];

    showSuccess(msg: string, isKey?: boolean): void;

    showError(msg: string, isCritical?: boolean, isKey?: boolean): void;

    showInfo(message: string): void;

    showMessage(msg?: ToastOptions): void;

    showWarning(msg: string, duration?: number, pos?: string): void;

    showConfirm(msg: string, type?: 'delete' | 'update', title?: string, size?: string): IModalInstanceService;

    showConflict(msg: string, title?: string);
}

class NotificationService implements INotificationService {
    static $inject = [
        '$uibModal',
        '$rootScope'
    ];

    constructor(private readonly $uibModal,
                private readonly $rootScope: WebshopRootScope) {
    }

    showConfirm(message: string, type: "delete" | "update" = "delete", title?: string, size?: string): IModalInstanceService {
        return this.$uibModal.open({
            templateUrl: 'Components/Dialogs/Common/confirm-message/ConfirmMessage.html?v=' + window['APP_CONFIG']?.version,
            controllerAs: '$ctrl',
            controller: 'confirm_message_ctrl',
            windowClass: 'conflict-rule-dialog',
            size: size || 'sm',
            resolve: {
                load: [
                    'LazyControllerFactory',
                    (lazyControllerFactory) => {
                        return lazyControllerFactory.load('confirm_message_ctrl',
                            'Components/Dialogs/Common/confirm-message/ConfirmMessageController');
                    }
                ],
                message: () => message,
                type: () => type,
                title: () => title
            }
        });
    }

    showConflict(message: string, title?: string) {
        return this.$uibModal.open({
            controllerAs: '$ctrl',
            templateUrl: 'Components/Dialogs/Common/conflict-message/ConflictMessage.html?v=' + window['APP_CONFIG']?.version,
            controller: 'show_conflict_message_ctrl',
            backdrop: 'static',
            windowClass: 'conflict-rule-dialog',
            resolve: {
                load: [
                    'LazyControllerFactory',
                    function (lazyControllerFactory) {
                        return lazyControllerFactory.load('show_conflict_message_ctrl',
                            'Components/Dialogs/Common/conflict-message/ShowConflictMessageController');
                    }
                ],
                message: () => message,
                title: () => title
            }
        });
    }

    // Thuộc tính lưu trữ các input bị vô hiệu hóa
    public disabledInput: any[] = [];

    // Cấu hình chung cho toast
    private readonly defaultPosition = 'top-right';

    private get toast(): any {
        return (window as any)['jQuery']?.toast;
    }

    private showToast(options: ToastOptions): void {
        if (!this.toast) {
            return;
        }

        this.toast({
            position: this.defaultPosition,
            loader: false,
            ...options
        });
    }

    public showSuccess(msg: string, isKey?: boolean): void {
        if (isKey) {
            msg = this.$rootScope.translate(msg);
        }

        this.showToast({
            text: msg,
            icon: 'success'
        });
    }

    public showError(msg: string, isCritical?: boolean, isKey?: boolean): void {
        if (isKey) {
            msg = this.$rootScope.translate(msg);
        }

        this.showToast({
            text: msg,
            icon: isCritical ? 'error' : 'warning',
            hideAfter: isCritical ? 0 : 10000,
        });
    }

    public showInfo(message: string): void {
        this.showToast({
            text: message,
            icon: 'info'
        });
    }

    public showMessage(msg: object = {}): void {
        this.showToast(msg);
    }

    public showWarning(msg: string, hideAfter?: number, pos?: string): void {
        this.showToast({
            text: msg,
            icon: 'warning',
            hideAfter: hideAfter ?? 10000,
            position: pos || this.defaultPosition
        });
    }
}

export const config = (app: IModule) =>
    app.service('Notification', NotificationService);